const MANAGED = 'data-seo-managed'

function upsertMeta(
  attr: 'name' | 'property',
  key: string,
  content: string,
): void {
  if (typeof document === 'undefined') return
  let el = document.head.querySelector<HTMLMetaElement>(
    `meta[${attr}="${key}"]`,
  )
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    el.setAttribute(MANAGED, 'true')
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

export function setTitle(title: string): void {
  if (typeof document === 'undefined') return
  document.title = title
}

export function setMetaName(name: string, content: string): void {
  upsertMeta('name', name, content)
}

export function setMetaProperty(property: string, content: string): void {
  upsertMeta('property', property, content)
}

export function setCanonical(href: string): void {
  if (typeof document === 'undefined') return
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]')
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', 'canonical')
    el.setAttribute(MANAGED, 'true')
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

export function setHtmlLang(lang: string): void {
  if (typeof document === 'undefined') return
  document.documentElement.setAttribute('lang', lang)
}

export function setJsonLd(id: string, data: unknown): void {
  if (typeof document === 'undefined') return
  const elementId = `jsonld-${id}`
  let el = document.getElementById(elementId) as HTMLScriptElement | null
  if (!el) {
    el = document.createElement('script')
    el.type = 'application/ld+json'
    el.id = elementId
    el.setAttribute(MANAGED, 'true')
    document.head.appendChild(el)
  }
  el.textContent = JSON.stringify(data)
}

export function removeJsonLd(id: string): void {
  if (typeof document === 'undefined') return
  document.getElementById(`jsonld-${id}`)?.remove()
}
